import { networkStatusNotifier } from '../client/networkStatusNotifier'

export const useApolloNetworkStatus = networkStatusNotifier.useApolloNetworkStatus
